import {
  Form,
  Input,
  Button,
  Card,
  Space,
  DatePicker,
  Table,
  Row,
  Col,
  Select,
} from "antd";
import moment from "moment";
import {
  SearchOutlined,
  ReloadOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import useFormAndRoute from "../../@hooks/useFormAndRoute";
import ReprotService from "../../@services/reprot";
import { useCallback, useEffect, useState } from "react";
import { download, parseTime } from "../../@utils";
import AuthComponent from "../../components/AuthComponent";

import "./StoreSalesReport.less";

moment.locale();
const DefaultFormData = {
  storeCode: [],
  name: "",
  dateRange: [moment("2021/09/29 00:00:00"), moment()],
};

const statisticDefault = [
  { label: "商品销量", value: 0, key: "saleCount" },
  { label: "销售额￥（含税）", value: 0, key: "salePrice" },
  { label: "销售成本￥（含税）", value: 0, key: "costPrice" },
  { label: "毛利￥（含税）", value: 0, key: "profitPrice" },
  { label: "税额￥", value: 0, key: "taxPrice" },
  { label: "销售额￥（不含税）", value: 0, key: "salePriceNotax" },
  { label: "销售成本￥（不含税）", value: 0, key: "costPriceNotax" },
  { label: "毛利￥（不含税）", value: 0, key: "profitPriceNotax" },
];

export default function StoreSalesReport() {
  const onFormDataChanged = useCallback((FormData) => {
    console.log("onFormDataChanged", FormData);
  }, []);

  const { form } = useFormAndRoute(DefaultFormData, onFormDataChanged);
  console.log(form.getFieldsValue());
  const [storeOptions, setStoreOptions] = useState([]);
  const [pager, setPager] = useState({
    page: 1,
    pageSize: 20,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共${total}条数据`,
  });

  const onReset = () => {
    form.resetFields();
    // form.submit()
  };
  const columns = [
    {
      title: "门店",
      dataIndex: "storeName",
      width: 120,
    },
    {
      title: "商品编码",
      dataIndex: "itemCode",
      width: 120,
    },
    {
      title: "商品条码",
      width: 120,
      dataIndex: "barcode",
    },
    {
      title: "商品名称",
      width: 180,
      dataIndex: "itemName",
    },
    {
      title: "商品销量",
      width: 140,
      dataIndex: "saleCount",
      sorter: true,
    },
    {
      title: "销售额￥（含税）",
      width: 160,
      dataIndex: "salePrice",
      sorter: true,
    },
    {
      title: "销售成本￥（含税）",
      width: 190,
      dataIndex: "costPrice",
      sorter: true,
    },
    {
      title: "毛利￥（含税）",
      width: 160,
      dataIndex: "profitPrice",
      sorter: true,
    },
    {
      title: "税率￥",
      width: 100,
      dataIndex: "taxRate",
    },
    {
      title: "税额￥",
      width: 100,
      dataIndex: "taxPrice",
    },
    {
      title: "销售额￥（不含税）",
      width: 180,
      dataIndex: "salePriceNotax",
      sorter: true,
    },
    {
      title: "销售成本￥（不含税）",
      width: 200,
      dataIndex: "costPriceNotax",
      sorter: true,
    },
    {
      title: "毛利￥（不含税）",
      width: 180,
      dataIndex: "profitPriceNotax",
      sorter: true,
    },
  ];
  const totalW = columns.map((w) => w.width ?? 180).reduce((n, m) => n + m);
  const [tableProps, setTableProps] = useState({
    loading: false,
    dataSource: [],
    // rowKey: 'itemCode',
    rowKey: () => {
      return Math.random();
    },
    columns,
  });
  // saleCount

  const [searchParams, setSearchParams] = useState({
    sortColumn: undefined,
    sortType: undefined,
  });

  const search = () => {
    const req = form.getFieldsValue() || {};
    req.startTime = undefined;
    req.endTime = undefined;
    if (Array.isArray(req.dateRange) && req.dateRange.length === 2) {
      req.startTime = moment(req.dateRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      req.endTime = moment(req.dateRange[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    }
    if (req.dateRange) {
      delete req.dateRange;
    }
    setSearchParams({ ...searchParams, ...req, dateRange: undefined });
    setPager((state) => ({ ...state, page: 1 }));
  };

  const [statistic, setStatistic] = useState([...statisticDefault]);
  useEffect(() => {
    const getData = async () => {
      try {
        setTableProps((state) => ({ ...state, loading: true }));
        const res =
          (await ReprotService.getList({
            ...searchParams,
            startTime: searchParams.startTime || "2021-09-29 00:00:00",
            endTime:
              searchParams.endTime || moment().format("YYYY-MM-DD HH:mm:ss"),
            storeCode:(searchParams.storeCode&&searchParams.storeCode.length>0)?searchParams.storeCode :storeOptions,
            pageIndex: pager.page,
            pageSize: pager.pageSize,
          })) || {};

        res.data = res.data || {};
        const statisticList = [...statisticDefault];
        statisticList.forEach((item) => {
          item.value = res.data[item.key] || 0;
        });

        setStatistic(statisticList);
        setPager((state) => ({ ...state, total: res.recordCount || 0 }));
        setTableProps((state) => ({
          ...state,
          dataSource: res.result || [],
        }));
      } catch (error) {
        console.log({ error });
      } finally {
        setTableProps((state) => ({ ...state, loading: false }));
      }
    };
    getData();
  }, [pager.pageSize, pager.page, searchParams, storeOptions]);

  const [ratesSelectProps, setRatesSelectProps] = useState({
    loading: false,
    options: [],
    allowClear: true,
  });

  const [storeSelectProps, setStoreSelectProps] = useState({
    options: [],
    mode: "multiple",
    loading: false,
  });

  useEffect(() => {
    const getStore = async () => {
      try {
        setStoreSelectProps((state) => ({ ...state, loading: true }));
        const res = (await ReprotService.getStore()) || [];
        setStoreSelectProps((state) => ({
          ...state,
          options: (res || []).map((item) => ({
            label: item.storeName,
            value: item.storeCode,
          })),
        }));
        setStoreOptions((res||[]).map((item)=>(item.storeCode)))
      } catch (error) {
        console.log({ error });
      } finally {
        setStoreSelectProps((state) => ({ ...state, loading: false }));
      }
    };
    getStore();

    const getTaxRates = async () => {
      try {
        setRatesSelectProps((state) => ({ ...state, loading: true }));
        const res = (await ReprotService.getTaxRates()) || {};
        setRatesSelectProps((state) => ({
          ...state,
          options: (res || []).map((val) => ({
            label: val,
            value: val,
          })),
        }));
      } catch (error) {
        console.log({ error });
      } finally {
        setRatesSelectProps((state) => ({ ...state, loading: false }));
      }
    };
    getTaxRates();
  }, [form]);

  const tableChangeHandler = (pagination, filters, sorter) => {
    console.log({ pagination, sorter });
    setSearchParams((state) => ({
      ...state,
      sortColumn: sorter.column ? sorter.column.dataIndex : undefined,
      sortType: sorter.order ? sorter.order.replace("end", "") : undefined,
    }));

    setPager((state) => ({
      ...state,
      page: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };

  const [exportStatus, setExportStatus] = useState({
    loading: false,
  });
  const exportHandler = async () => {
    try {
      setExportStatus((state) => ({ ...state, loading: true }));
      const req = form.getFieldsValue() || {};
      if (Array.isArray(req.dateRange) && req.dateRange.length === 2) {
        req.startTime = moment(req.dateRange[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        req.endTime = moment(req.dateRange[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      const res = await ReprotService.export({
        ...searchParams,
        ...req,
        pageIndex: pager.page,
        pageSize: pager.pageSize,
        startTime: searchParams.startTime || "2021-09-29 00:00:00",
        endTime:
          searchParams.endTime || moment().format("YYYY-MM-DD HH:mm:ss"),
        storeCode:(searchParams.storeCode&&searchParams.storeCode.length>0)?searchParams.storeCode :storeOptions,
      });

      download(
        res,
        "门店销售报表" + parseTime(Date.parse(new Date())) + ".csv"
      );
    } catch (error) {
      console.log({ error });
    } finally {
      setExportStatus((state) => ({ ...state, loading: false }));
    }
  };

  return (
    <Space
      direction="vertical"
      style={{ width: "100%", textAlign: "left" }}
      className={"store-sales-report-pager"}
    >
      <Card bodyStyle={{ paddingRight: "8px" }}>
        <Form form={form} layout="inline" onFinish={search} onReset={onReset}>
          <Row gutter={[16, 16]} style={{ width: "100%" }}>
            <Col span={6}>
              <Form.Item
                name="storeCode"
                label="销售门店"
                style={{ marginRight: 0 }}
              >
                <Select
                  placeholder="请选择内容"
                  {...storeSelectProps}
                  optionFilterProp="label"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="itemName"
                label="商品名称"
                style={{ marginRight: 0 }}
              >
                <Input placeholder="请输入内容" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="itemCode"
                label="商品编码"
                style={{ marginRight: 0 }}
              >
                <Input placeholder="请输入内容" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="barcode"
                label="商品条码"
                style={{ marginRight: 0 }}
              >
                <Input placeholder="请输入内容" style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={"dateRange"}
                label="销售日期"
                style={{ marginRight: 0 }}
              >
                <DatePicker.RangePicker
                  showTime
                  style={{ width: "100%" }}
                ></DatePicker.RangePicker>
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={6}>
              <Form.Item
                name="taxRate"
                label="商品税率"
                style={{ marginRight: 0 }}
              >
                <Select placeholder="请选择内容" {...ratesSelectProps} style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={6} style={{ marginRight: 0 }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Form.Item>
                  <Button
                    htmlType="submit"
                    icon={<SearchOutlined />}
                    ghost
                    type="primary"
                  >
                    搜索
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button
                    htmlType="button"
                    icon={<ReloadOutlined />}
                    onClick={onReset}
                    ghost
                    type="primary"
                  >
                    重置
                  </Button>
                </Form.Item>
                <AuthComponent authKey={"/report/product-sale/export"}>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="button"
                      icon={<ExportOutlined />}
                      onClick={exportHandler}
                      loading={exportStatus.loading}
                    >
                      导出
                    </Button>
                  </Form.Item>
                </AuthComponent>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
      <Card bodyStyle={{ paddingRight: "8px" }} loading={tableProps.loading}>
        <Row gutter={16} className={"statistic-card"}>
          {statistic.map((item) => (
            <Col style={{ width: "25%" }} key={item.key}>
              <div className={"statistic-value"}>{item.value}</div>
              <div className={"statistic-label"}>{item.label}</div>
            </Col>
          ))}
        </Row>
      </Card>
      <Card>
        <Table
          {...tableProps}
          pagination={pager}
          scroll={{x: totalW}}
          onChange={tableChangeHandler}
        />
      </Card>
    </Space>
  );
}